var _path, _path2, _path3, _line, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyCarWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 141,
    viewBox: "0 0 146 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1223 107.116L36.9564 95.0876C51.2777 94.3703 57.2495 97.5705 65.3225 106.95L37.1223 107.116ZM11.4656 107.171C14.1197 99.8327 23.6857 96.3566 31.4269 95.4738L31.5928 107.061L11.4656 107.171ZM74.2249 107.061C61.5624 90.0115 51.333 86.9769 33.1963 88.4666C5.71496 90.5081 0.683153 103.419 1.01492 126.261C1.01492 126.317 1.01492 126.372 1.01492 126.427C1.07021 128.303 2.56317 129.848 4.49848 129.848L9.47499 129.793C9.80675 123.117 15.2809 117.765 22.0821 117.709C28.9387 117.654 34.5234 122.951 35.0764 129.627L56.1436 129.517C56.4753 122.841 61.9495 117.489 68.7507 117.433C75.6073 117.378 81.192 122.675 81.7449 129.351H85.6156C87.5509 129.351 89.0438 127.751 89.0438 125.93C88.9885 121.351 90.5368 112.744 74.2249 107.061ZM66.8707 132.938C65.4884 131.779 65.2672 129.793 66.3731 128.413C67.479 127.034 69.5249 126.868 70.9072 127.972C72.2896 129.131 72.5108 131.117 71.4049 132.496C70.299 133.876 68.2531 134.041 66.8707 132.938ZM74.8331 123.227C70.7966 119.916 64.8801 120.468 61.6177 124.496C58.3554 128.468 58.9636 134.372 63.0001 137.683C67.0366 140.993 72.9531 140.441 76.2155 136.414C79.4779 132.441 78.8143 126.537 74.8331 123.227ZM20.3127 133.103C18.9304 131.945 18.7092 129.958 19.8151 128.579C20.921 127.199 22.9669 127.034 24.3492 128.137C25.7316 129.296 25.9528 131.282 24.8469 132.662C23.741 134.096 21.6951 134.262 20.3127 133.103ZM28.2751 123.448C24.2386 120.137 18.3221 120.689 15.0597 124.717C11.7974 128.689 12.4056 134.593 16.4421 137.903C20.4786 141.214 26.3951 140.662 29.6575 136.634C32.9199 132.607 32.2563 126.703 28.2751 123.448Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0314 69.1563H2.53699V38.5322H48.7762V2H97.8559V48.0781V85.1563M106.856 132.414L143.526 132.056V61.9835V46.5322L97.8559 15.5",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3903 63.3613V66.1752H56.4915C56.8786 66.1752 57.2103 66.5063 57.2103 66.8925C57.2103 67.2787 56.8786 67.6098 56.4915 67.6098H54.3903V70.4237H56.4915C56.8786 70.4237 57.2103 70.7547 57.2103 71.141C57.2103 71.5272 56.8786 71.8582 56.4915 71.8582H54.3903V74.6722H58.648V63.4164H54.3903V63.3613ZM54.3903 60.5473H58.648C60.1963 60.5473 61.468 61.8164 61.468 63.3613V74.617C61.468 76.1619 60.1963 77.4309 58.648 77.4309H54.3903C54.3903 78.2034 53.7821 78.8655 52.9527 78.8655H46.3173C46.0409 78.8655 45.7644 78.7551 45.5432 78.6448L37.4149 74.6722H34.5949C33.8208 74.6722 33.1572 74.0652 33.1572 73.2376V64.7958C33.1572 64.0234 33.7655 63.3613 34.5949 63.3613H37.4149L45.5432 59.3887C45.7644 59.2231 46.0409 59.168 46.3173 59.168H52.9527C53.7268 59.168 54.3903 59.7749 54.3903 60.5473Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64.0146,
    y1: 20,
    x2: 83.0146,
    y2: 20,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64.0146,
    y1: 44,
    x2: 83.0146,
    y2: 44,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 112.015,
    y1: 68,
    x2: 131.015,
    y2: 68,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 112.015,
    y1: 44,
    x2: 119.015,
    y2: 44,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyCarWhite);
export default __webpack_public_path__ + "static/media/companyCarWhite.aace54990395f290b5fc9fe6dc28d2f3.svg";
export { ForwardRef as ReactComponent };